<template>
  <v-container
    fluid
    class="d-flex justify-center align-center flex-column"
    fill-height
  >
    <v-img
      style="flex-grow: 0"
      contain
      width="300"
      :src="require('@/assets/nexus-logo.png')"
    />
    <span
      class="title-font mt-4"
      style="font-size: 17px; letter-spacing: 0.25ch"
    >
      Scan Analyzer Tool
    </span>
  </v-container>
</template>

<script>
export default {
  name: "ConnectBranding"
}
</script>
